import { render, staticRenderFns } from "./PageFAQ.vue?vue&type=template&id=4ad5da0c&scoped=true"
import script from "./PageFAQ.vue?vue&type=script&lang=js"
export * from "./PageFAQ.vue?vue&type=script&lang=js"
import style0 from "./PageFAQ.vue?vue&type=style&index=0&id=4ad5da0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad5da0c",
  null
  
)

export default component.exports